import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import AppProvider from './common/context-providers/AppProvider';

import App from './App';
import { queryClient } from './api/client';
import '@/common/utils/initFA';
import '@/styles/scss/theme.scss';
import '@/styles/scss/user.scss';
import '@/i18n';

const container = document.getElementById('root')!;

const root = createRoot(container);

root.render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />
      <AppProvider>
        <App />
      </AppProvider>
    </QueryClientProvider>
  </StrictMode>
);
